var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import ReactCrop from 'react-image-crop';
import { useMediaQuery } from 'react-responsive';
import styles from './ImageInput.module.css';
import Button from '../Button';
import { createPortal } from 'react-dom';
import { getCroppedImg } from './utils';
function aspectToNumber(value) {
    if (typeof value === 'string') {
        var _a = __read(value.split('/').map(Number), 2), numerator = _a[0], denominator = _a[1];
        if (denominator === 0) {
            return undefined;
        }
        return numerator / denominator;
    }
    return undefined;
}
/**
 * Кадрирование происходит в этом компоненте, основан на React Image Crop
 * https://www.npmjs.com/package/react-image-crop
 * */
export default function CropEditor(_a) {
    var _b;
    var image = _a.image, close = _a.close, updateImage = _a.updateImage, aspect = _a.aspect;
    var aspectArray = Array.isArray(aspect) ? aspect : [];
    var _c = __read(useState(aspectArray.length && aspectToNumber(aspectArray[0])), 2), newAspect = _c[0], setNewAspect = _c[1];
    aspect = aspectArray.length ? newAspect : aspect;
    var initialCrop = { aspect: aspect };
    var _d = __read(useState(initialCrop), 2), crop = _d[0], setCrop = _d[1];
    var changeAspect = function (value) {
        var aspect = aspectToNumber(value);
        setNewAspect(aspect);
        setCrop({ aspect: aspect });
    };
    var _e = __read(useState(image), 2), croppedImage = _e[0], setCroppedImage = _e[1];
    var imageUrl = useMemo(function () { return URL.createObjectURL(croppedImage); }, [
        croppedImage
    ]);
    var containerRef = useRef(null);
    var imageElement = (_b = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _b === void 0 ? void 0 : _b.getElementsByTagName('img')[0];
    useEffect(function () {
        document.getElementById('root').style.paddingRight = '15px';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
        return function () {
            document.getElementById('root').style.paddingRight = 'initial';
            document.body.style.width = 'initial';
            document.body.style.overflow = 'initial';
        };
    }, []);
    var acceptCrop = function () {
        if (imageElement) {
            getCroppedImg(imageElement, crop, image.name).then(function (file) {
                setCroppedImage(file);
                setCrop(initialCrop);
            });
        }
    };
    var rejectCrop = function () {
        setCrop(initialCrop);
    };
    var rejectCropAndClose = function () {
        setCrop(initialCrop);
        close();
    };
    var saveAndClose = function () {
        updateImage(croppedImage);
        close();
    };
    var buttonStyle = { minWidth: 186 };
    var isDesktop = useMediaQuery({ query: '(min-width: 601px)' });
    var imageStyle = __assign({ objectFit: 'contain' }, (isDesktop
        ? { maxHeight: '50vh', maxWidth: '50vw' }
        : { maxHeight: '65vh' }));
    var isCropping = crop.width;
    var element = (React.createElement("div", { className: styles.backdrop, onClick: function (event) { return event.stopPropagation(); } },
        React.createElement("div", { className: styles.cropContainer, ref: containerRef },
            React.createElement("div", { className: styles.closeButtonContainer },
                React.createElement("div", { className: styles.aspectButtonContainer }, aspectArray.length ? (aspectArray.map(function (aspect, index) {
                    return (React.createElement("button", { key: index, className: newAspect === aspectToNumber(aspect)
                            ? styles.aspectButtonOn
                            : styles.aspectButton, onClick: function () { return changeAspect(aspect); } }, aspect ? aspect : 'Свободное'));
                })) : (React.createElement(React.Fragment, null))),
                React.createElement("button", { className: styles.closeButton, onClick: rejectCropAndClose })),
            React.createElement("div", { className: styles.imageBackground },
                React.createElement(ReactCrop, { src: imageUrl, crop: crop, onChange: function (newCrop) {
                        return setCrop(__assign(__assign({}, newCrop), { aspect: aspect }));
                    }, className: styles.imageContainer, imageStyle: imageStyle })),
            React.createElement("div", { className: styles.buttonContainer }, isCropping ? (React.createElement(React.Fragment, null,
                React.createElement(Button, { title: '\u041E\u0442\u043C\u0435\u043D\u0430', onClick: rejectCrop, style: buttonStyle }),
                React.createElement(Button, { title: '\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C', onClick: acceptCrop, style: buttonStyle }))) : (React.createElement(Button, { title: '\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438 \u0437\u0430\u043A\u0440\u044B\u0442\u044C', onClick: saveAndClose, style: buttonStyle }))))));
    return createPortal(element, document.getElementById('root'));
}
